export const programControlSections = {
  registration: 'registration',
  sweeps: 'sweeps',
  developers: 'developers',
  funding: 'funding',
  instantDeposit: 'instantDeposit',
  orders: 'orders',
  batchOrder: 'batchOrder',
  books: 'books',
  accountNumbers: 'accountNumbers',
} as const;

export type ProgramControlSection = (typeof programControlSections)[keyof typeof programControlSections];

export type ProgramControlDefinitionId = ProgramControlSection | `${ProgramControlSection}.${string}`;
